export const getDataLayer = () => {
    if (!('dataLayer' in window)) {
        if (typeof window !== 'undefined') {
            window.dataLayer = [];
            return window.dataLayer;
        }
        return [];
    }
    return window.dataLayer;
};
//# sourceMappingURL=dataLayer.js.map